'use strict';

module.exports = '<li class="ad-component_list-item <%= className %>"><%= linkComponent %></li>';



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/ad-li.tpl.js
// module id = 15
// module chunks = 0